import { DropDownButton as KendoDropDownButton, DropDownButtonProps as KendoDropDownButtonProps} from '@progress/kendo-react-buttons';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Icon, useSvgIcon } from 'components';
import { useMemo, useState } from 'react';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import styles from './DropDownButton.module.scss';

export type DropDownButtonProps = {
    iconDefinition?: IconDefinition,
    iconPosition?: 'left' | 'right'
} & KendoDropDownButtonProps;

export const DropDownButton = ({ iconDefinition, className, iconPosition, text, onItemClick, ...rest }: DropDownButtonProps) => {

    const svgIcon = useSvgIcon(iconDefinition);   

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const setOpen = () => setIsOpen(true);
    const setClosed = () => setIsOpen(false);
    
    const ChavronIcon = useMemo(()=> (isOpen ? 
            <Icon 
                icon={faChevronUp}
                className={styles.chevronIcon}    
            />  
        : 
            <Icon 
                icon={faChevronDown}
                className={styles.chevronIcon}
                /> 
        ), [isOpen]);
    
    return (
        <KendoDropDownButton        
            {...rest} 
            svgIcon={svgIcon}
            onOpen={() => setOpen()}
            onClose={() => setClosed()}
            onItemClick={(e) => { 
                if(onItemClick)
                    onItemClick(e); 
                setClosed();
            }}
            text = {<span className={styles.text}> <span> {text} </span> {ChavronIcon} </span>} 
            buttonClass={styles.button}
            className={styles.control} 
        />
    );
};